const dateOptions: {
    [key: string]: string;
} = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
};

const dateTimeOptions: {
    [key: string]: string;
} = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric', // ,
    // second: 'numeric'
};

export const formatDate = (date: string | Date | null | undefined, options: Intl.DateTimeFormatOptions = dateOptions) => {
    if (date == null) return '';

    let local = viewModel.CurrentUser() ? viewModel.CurrentUser().Language.Culture() : navigator.language;

    if (local.startsWith('ks')) local = 'en-US';

    return new Intl.DateTimeFormat(local, options).format(new Date(date));
};

export const formatDateTime = (date: string | Date | null | undefined, options: Intl.DateTimeFormatOptions = dateTimeOptions) => {
    if (date == null) return '';

    let local = viewModel.CurrentUser() ? viewModel.CurrentUser().Language.Culture() : navigator.language;

    if (local.startsWith('ks')) local = 'en-US';

    let dateObj = new Date(date);

    if (!isValidDate(dateObj)) return date;

    return new Intl.DateTimeFormat(local, options).format(new Date(date));
};

export function isValidDate(d: any) {
    return d instanceof Date && !isNaN(d as any);
}
